import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { PUBLIC_ROUTE } from '@router/route.constants';
import {
    useDispatch,
    useSelector,
} from 'react-redux';
import {
    api,
} from '@api';
import {
    clearToken,
    clearUser,
} from '@redux/auth/authSlice';
import { localStorage } from '@utils';
import { useTranslation } from 'react-i18next';

const Modal = styled(AntModal)`

.ant-modal-title {
text-align: center;
color: ${props => props.theme.primaryColor};
}

.ant-modal-content {
    text-align: center;
    color: #ff4d4f;
}

.ant-modal-footer {
    text-align: center;

    .ant-btn-default {
        display: none !important;
    }

    .ant-btn {
        min-width: 76px;
    }
}
`;

const AccountLockedDialog = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isLocked = useSelector(state => state.auth.isLocked);

    const resetSessionState = () => {
        // clear token and user from redux
        dispatch(clearToken());
        dispatch(clearUser());

        // clear token and user from localstorage
        localStorage.clearToken();
        localStorage.clearUser();

        // update token to request obj
        api.setSessionToken('');

        navigate(`/${PUBLIC_ROUTE.LOGIN}`);
    }

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            width={320}
            open={isLocked}
            onOk={resetSessionState}
            title={t('common.notice')}
            okText={t('common.ok')}
        >
            {t('error.accountLockedMessage')}
        </Modal>
    );
}

export default AccountLockedDialog;